export default __webpack_public_path__ + "static/media/alert-circle-no-bg.891ed473.svg";